import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import ProductLabels from './ProductLabels.component';

const mapStateToProps = (state) => ({
    labels: state.LabelReducer?.labels
})
const mapDispatchToProps = () => ({})

export class ProductLabelsContainer extends PureComponent {
    static propTypes = {
        discount: PropTypes.object.isRequired,
        labels: PropTypes.array.isRequired,
        sf_labels: PropTypes.string.isRequired
    }

    getLabels() {
        const { discount, labels = [], sf_labels = '' } = this.props;

        const labelIds = sf_labels?.split(",") ?? [];

        const filteredLabels = labels.filter(({ id }) => labelIds.includes(id));
        const labelsWithVerifiedDiscount = filteredLabels.filter(({ show_discount }) => !(show_discount && discount?.percentOff === 0))

        return labelsWithVerifiedDiscount.map((label) => {
            if (label?.show_discount) {
                return {
                    ...label,
                    name: `-${Math.ceil(discount?.percentOff)}%`
                }
            }

            return label;
        })
    }

    render() {
        return <ProductLabels labels={ this.getLabels() } />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductLabelsContainer)
